import React, { useEffect } from 'react';
import Header from './Component/Header';
import Footer from './Component/Footer';
import PageHero from './Component/PageHero';
import myImage from './Component/google-review.png';

const REVIEW_WIDGET_SRC =
  'https://app.salescaptain.com/api/v1/user/review-widget/d317fc79-08a2-4fca-b434-99ff99f41618';

function Reviews() {
  useEffect(() => {
    const container = document.getElementById('salescaptain-review-widget');
    if (!container) return;

    let cancelled = false;

    // Defer so React Strict Mode's first mount/cleanup cancels before we inject
    const timer = window.setTimeout(() => {
      if (cancelled) return;

      container.innerHTML = '';
      document
        .querySelectorAll(`script[src="${REVIEW_WIDGET_SRC}"]`)
        .forEach((el) => el.remove());

      const script = document.createElement('script');
      script.src = REVIEW_WIDGET_SRC;
      script.defer = true;
      script.type = 'text/javascript';
      document.body.appendChild(script);
    }, 0);

    return () => {
      cancelled = true;
      window.clearTimeout(timer);
      container.innerHTML = '';
      document
        .querySelectorAll(`script[src="${REVIEW_WIDGET_SRC}"]`)
        .forEach((el) => el.remove());
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#f7f8fa] text-slate-900 antialiased">
      <Header />
      <PageHero
        eyebrow="Customer feedback"
        title="Reviews"
        subtitle="How did we do? Leave us a review below"
      />

      <section className="pb-16 md:pb-24">
        <div className="mx-auto flex max-w-5xl flex-col items-center gap-8 px-4 sm:px-6">
          <div className="w-full rounded-[1.75rem] bg-white p-6 shadow-sm ring-1 ring-slate-200/80 sm:p-8">
            <div id="salescaptain-review-widget" />
          </div>

          {/* <div className="w-full max-w-3xl rounded-[1.75rem] bg-white p-6 text-center shadow-sm ring-1 ring-slate-200/80 sm:p-10">
            <p className="text-sm text-slate-500 sm:text-base">
              The San Rafael, CA area trusts PacifiContract for flooring. Share your experience on
              Google.
            </p>
            <a
              href="https://www.google.com/maps/place/Pacific+Contract/@37.9681707,-122.5282297,17z/data=!4m8!3m7!1s0x808599f81c5f6e01:0xc00c65e1f339f07f!8m2!3d37.9681665!4d-122.5256548!9m1!1b1!16s%2Fg%2F1tdc5f_7?hl=en&entry=ttu"
              target="_blank"
              rel="noreferrer"
              className="mt-6 inline-block"
            >
              <img
                src={myImage}
                alt="Leave a Google review"
                className="mx-auto max-h-40 w-auto object-contain sm:max-h-52"
              />
            </a>
            <a
              href="https://www.google.com/maps/place/Pacific+Contract/@37.9681707,-122.5282297,17z/data=!4m8!3m7!1s0x808599f81c5f6e01:0xc00c65e1f339f07f!8m2!3d37.9681665!4d-122.5256548!9m1!1b1!16s%2Fg%2F1tdc5f_7?hl=en&entry=ttu"
              target="_blank"
              rel="noreferrer"
              className="mt-6 inline-flex items-center justify-center rounded-full bg-[#0075ca] px-5 py-2.5 text-sm font-semibold text-white no-underline transition hover:bg-[#0063ad] sm:text-base"
            >
              Write a review
            </a>
          </div> */}
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Reviews;
